/*
* Surround a string with quotes
*/
const quoteText = (text:string): string => {
    return `\"${text}\"`;
}

export default {
    quoteText
};